// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Kvct","boxTitle":"Qualiphy_boxTitle__2Vc5o","box":"Qualiphy_box__zyblB","toggleWrap":"Qualiphy_toggleWrap__2dUKy"};